<template>
  <div id="app" :class="appLangClass">
    <router-view />
    <Footer></Footer>
  
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { currentLanguage } from './utils/lang'
  const appLangClass = computed(() => currentLanguage.value === 'en' ? 'lang-en' : 'lang-zh')
</script>

<script>
    function isMobileDevice() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // 检查移动端标识
        return /iPhone|iPad|iPod|Android|BlackBerry|Opera Mini|IEMobile/i.test(userAgent);
    }
    
    if (isMobileDevice()) {
        console.log('当前为移动端设备');
        localStorage.setItem('userAgent', 'Mobile')
    } else {
        console.log('当前为非移动端设备');
        localStorage.setItem('userAgent', 'PC')
    }
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
a{
  text-decoration: none;
  color: black;
}
#app {
  font-family: '方正大黑简体';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.flex{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flexs{
  flex: 1;
}
.maskbox{
    position: fixed;
    width: 100%;
    height: 100%;
    background: black;
    top: 0;
    left: 0;
    z-index: 2;
    opacity: .3;
}
.lang-zh .app-ban {
  font-family: 'OPPOSansR', sans-serif;
  font-weight: normal !important;
}
.lang-en .app-ban {
  font-family: 'AkrobatSemiBold', sans-serif;
  font-weight: normal !important;
}
.lang-zh .app-title {
  font-family: 'OPPOSansH', sans-serif;
  font-weight: normal !important;
}
.lang-en .app-title {
  font-family: 'AkrobatExtraBold', sans-serif;
  font-weight: normal !important;
}
.lang-zh .app-content {
  font-family: 'OPPOSansL', sans-serif;
}
.lang-en .app-content {
  font-family: 'AkrobatExtraLight', sans-serif;
}
</style>